import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_loyalty_event.js";
//#region src/bite_log_loyalty_event_helper.ts
var bite_log_loyalty_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 0: return "ok";
		case 1: return "authed";
		case 2: return "auth-error";
		case 3: return "auth-skipped";
		case 4: return "rewards-fetched";
		case 5: return "rewards-fetch-error";
		case 6: return "rewards-fetch-skipped";
		case 7: return "rewards-applied";
		case 28: return "rewards-best-effort-failed";
		case 8: return "rewards-apply-error";
		case 9: return "rewards-apply-skipped";
		case 10: return "reward-removed";
		case 11: return "reward-remove-error";
		case 12: return "reward-remove-skipped";
		case 13: return "gift-card-balance-inquiry";
		case 14: return "gift-card-inquiry-error";
		case 15: return "gift-card-inquiry-skipped";
		case 16: return "gift-card-applied";
		case 17: return "gift-card-apply-error";
		case 18: return "gift-card-apply-skipped";
		case 19: return "gift-card-refunded";
		case 20: return "gift-card-refund-error";
		case 21: return "gift-card-refund-skipped";
		case 22: return "coupon-applied";
		case 23: return "coupon-apply-error";
		case 24: return "coupon-apply-skipped";
		case 25: return "coupon-removed";
		case 26: return "coupon-remove-error";
		case 27: return "coupon-remove-skipped";
		case 29: return "coupon-single-redemption-redeemed";
		case 51: return "comp-card-applied";
		case 52: return "comp-card-apply-error";
		case 53: return "comp-card-removed";
		case 54: return "comp-card-remove-error";
		case 61: return "loyalty-failed-to-check-in";
		case 30: return "reward-code-redeemed";
		case 31: return "reward-code-redeem-error";
		case 32: return "reward-code-redeem-skipped";
		case 40: return "tip-redeemed-on-loyalty";
		case 41: return "tip-redeem-on-loyalty-error";
		case 42: return "reward-fetched-on-loyalty";
		case 43: return "reward-fetched-on-loyalty-error";
		case 60: return "loyalty-sign-up-error";
	}
}
//#endregion
export { bite_log_loyalty_event_helper_exports, name };

//# sourceMappingURL=bite_log_loyalty_event_helper.js.map